import * as general from '../general';

export interface CompanyMappingRefFromProjectPostBody {
	name?: string;
	rename?: string;
}

export interface CompanyMappingRefFromProjectPostRequest {
  projectId: number;
	companyId: number;
	Body: CompanyMappingRefFromProjectPostBody;
}

export function postCompanyMappingRefFromProjectSuccess(projectImportId: number): general.SuccessReturnBody {
  return general.getSuccessReturnBody(projectImportId);
}

export function postCompanyMappingRefFromProjectServerErrorReturn(): general.ServerErrorReturnBody {
	return general.getServerErrorReturnBody();
}

export function postCompanyMappingReFromProjectUnauthorized(): general.UnauthorizedReturnBody {
	return general.getUnauthorizedReturnBody();
}
